import moment from 'moment';

import styles from './UserManagement.module.scss';

interface ILastActiveProps {
	lastActiveField: string | undefined;
}

const UserColumnLastActive = (props: ILastActiveProps) => {
	const { lastActiveField } = props;
	return (
		<div data-testid="user-last-active-column">
			{lastActiveField ? (
				<div className={styles['user-email-column']}>
					{moment(lastActiveField, 'YYYY/MM/DD').format('D MMM , YYYY ')}
				</div>
			) : null}
		</div>
	);
};

export default UserColumnLastActive;
